import React from "react";

export default function Banners(props) {
    const banners = props.banners;

    if (banners == null) {
        return null;
    }

    const config = window.appConfig;
    const handlers = config?.handlers ?? null;

    return (
        <div className="c_64">
            {banners.map(banner => {
	            return (
                    <>
                        {config?.IS_MOBILE_APP ?
                            <div key={banner.id} className="c_64_1" onClick={() => handlers.navigateToExternalUrl(banner.url)}>
                                <img src={banner.imageUrl} className="c_64_1_1" alt="" />
                            </div>
                            :
                            <a key={banner.id} href={banner.url} rel="noopener noreferrer" className="c_64_1">
                                <img src={banner.imageUrl} className="c_64_1_1" alt="" />
                            </a>
                        }
                    </>
                );
	        })}
        </div>
    );
}
